import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { authFetchBaseQuery, baseUrl } from './apiConfig';
import { ResponseBase } from './request';

const baseEndpointUrl = `${baseUrl}`;
const apiPrefix = 'account';

export interface SupportItem {
  createdAt: string;
  createdBy: string;
  id: number;
  name: string;
  status: number;
  updatedAt: string;
}

interface SupportItemsResponse extends ResponseBase {
  data: SupportItem[];
}

interface TicketCreateRequest {
  subject?: string;
  email?: string;
  globalHomeId?: string;
  description?: string;
  unitId?: string;
  appVersion?: string;
}

export const accountApi = createApi({
  reducerPath: 'accountApi',
  baseQuery: authFetchBaseQuery({
    baseUrl: baseEndpointUrl,
  }),
  endpoints: (builder) => ({
    getSupportList: builder.query<SupportItem[], void>({
      query: () => ({ url: `${apiPrefix}/support/get` }),
      transformResponse: (response: SupportItemsResponse) => response.data,
    }),
    createSupportTicket: builder.mutation<unknown, TicketCreateRequest>({
      query: (arg) => ({
        url: `${apiPrefix}/support/ticket/create`,
        method: 'POST',
        body: {
          subject: arg.subject,
          email: arg.email,
          globalhome_support_id: arg.globalHomeId,
          description: arg.description,
          unit_id: arg.unitId,
          app_version: arg.appVersion,
        },
      }),
    }),
  }),
});

export const { useGetSupportListQuery, useCreateSupportTicketMutation } = accountApi;
